var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-modal",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "confirm-delete-action-modal",
      attrs: { title: "Weet je zeker dat je deze actie wilt verwijderen?" },
      on: { close: _vm.cancel },
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c("ui-table", [
            _c(
              "thead",
              [
                _c("ui-table-header", [
                  _c("th", [_vm._v("Actie")]),
                  _c("th", [_vm._v("Bruto")]),
                  _c("th", [_vm._v("Netto")]),
                  _c("th", [_vm._v("Tarra")]),
                  _c("th", [_vm._v("Bustal")]),
                  _c("th", [_vm._v("Stukstal")]),
                ]),
              ],
              1
            ),
            _c(
              "tbody",
              [
                _vm.action
                  ? _c("ui-tr", [
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.actionDisplayName) +
                            " (" +
                            _vm._s(
                              _vm._f("date")(_vm.action.date, "DD-MM-YYYY")
                            ) +
                            ")"
                        ),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatWeight(_vm.action.brutoWeight))
                        ),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatWeight(_vm.action.nettoWeight))
                        ),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatPercentage(_vm.action.tarra))),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatNumber(_vm.action.bustal))),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatNumber(_vm.action.stukstal))),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm.deletableActions && _vm.deletableActions.length > 0
            ? [
                _c("ui-table", [
                  _c(
                    "thead",
                    [
                      _c(
                        "ui-table-header",
                        [
                          _c(
                            "ui-th",
                            {
                              staticClass: "warning-header",
                              attrs: { colspan: "100%" },
                            },
                            [
                              _c("div", { staticClass: "warning-content" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "warning-icon",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "20",
                                      height: "20",
                                      fill: "currentColor",
                                      viewBox: "0 0 256 256",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z",
                                      },
                                    }),
                                  ]
                                ),
                                _c("span", { staticClass: "warning-text" }, [
                                  _vm._v(
                                    "Let op! Alle acties die na deze actie zijn uitgevoerd worden ook verwijderd:"
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ui-table-header",
                        [
                          _c("ui-th", [_vm._v("Actie")]),
                          _c("ui-th", [_vm._v("Bruto")]),
                          _c("ui-th", [_vm._v("Netto")]),
                          _c("ui-th", [_vm._v("Tarra")]),
                          _c("ui-th", [_vm._v("Bustal")]),
                          _c("ui-th", [_vm._v("Stukstal")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "tbody",
                    _vm._l(_vm.deletableActions, function (subsequentAction) {
                      return _c(
                        "ui-tr",
                        {
                          key: `${subsequentAction.__typename}_${subsequentAction.id}`,
                        },
                        [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("actionTypeTitle")(
                                  subsequentAction.__typename,
                                  subsequentAction
                                )
                              ) +
                                " (" +
                                _vm._s(
                                  _vm._f("date")(
                                    subsequentAction.date,
                                    "DD-MM-YYYY"
                                  )
                                ) +
                                ")"
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatWeight(subsequentAction.brutoWeight)
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatWeight(subsequentAction.nettoWeight)
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatPercentage(subsequentAction.tarra)
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.formatNumber(subsequentAction.bustal))
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatNumber(subsequentAction.stukstal)
                              )
                            ),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modal-actions" },
            [
              _c("ui-button", { on: { click: _vm.cancel } }, [
                _vm._v("Annuleren"),
              ]),
              _c(
                "ui-button",
                {
                  attrs: { color: "negative" },
                  on: { click: _vm.confirmDelete },
                },
                [_vm._v(" " + _vm._s(_vm.deleteButtonText) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }